import { useMutation } from "react-query";
import { showNotification } from "@mantine/notifications";

import { deleteThread } from "modules/chat/api/threads";

export const useDeleteChatThreadMutation = () => {
  return useMutation({
    mutationFn: deleteThread,
    onError: () => {
      showNotification({
        message: "Failed to delete chat thread",
        color: "red"
      });
    }
  });
};
